import React from "react";
import { UiGrayListCard } from "./UiGrayListCard";
import { commonConstants } from "../../../_redux/_constants";

export const UiNotificationCard = (props) => {
  return (
    <>
      <UiGrayListCard className="df-notification-card">
        <div className="df-notification-card__icon">
          <img src={props.icon} />
        </div>
        <div>
          <h4>
            {props?.title?.length >
            commonConstants.SECUIRE_MAIL_TOAST_TITLE_CHARACTER_LENGTH
              ? props?.title?.slice(
                  0,
                  commonConstants.SECUIRE_MAIL_TOAST_TITLE_CHARACTER_LENGTH,
                ) + "..."
              : props?.title}
          </h4>
          <p className="df-notification-card__desc">
            {" "}
            {props?.message?.length >
            commonConstants.SECUIRE_MAIL_TOAST_CHARACTER_LENGTH
              ? props?.message?.slice(
                  0,
                  commonConstants.SECUIRE_MAIL_TOAST_CHARACTER_LENGTH,
                ) + "..."
              : props?.message}
          </p>
          <p className="df-notification-card__date">{props?.date}</p>
        </div>
      </UiGrayListCard>
    </>
  );
};
